export default {
	"order.SigningFailedPleaseSignAgain": "簽約失敗,請重新簽約",
	"order.TheDeductionWasUnsuccessfulAndTheOrderListIsBeingRedirected": "扣款未成功，正在跳轉訂單列表",
	"order.PleaseConfirmThatYouHaveReadAndAgree": "請確認您已閱讀並同意",
	"order.UserServicesAgreement": "《用戶服務協議》",
	"order.return": "返回",
	"order.agreeAndContinue": "同意並繼續",
	"order.MallCashierPagepaymentMethod": "商城收銀台頁_支付方式",
	"order.WeChat": "微信",
	"order.Alipay": "支付寶",
	"order.MallCashierPageorderButton": "商城收銀台頁_下單按鈕",
	"order.SorryPricesHaveChanged": "抱歉，價格已發生變化!",
	"order.SystemErrorPleaseTryAgainLater": "系統錯誤,請稍後再試",
	"order.AlipaySignedAContract": "支付寶簽約",
	"order.recommend": "推薦",
	"order.MallCashierPagePaymentConfirmationPopup": "商城收銀台頁_支付確認彈窗",
	"order.AfterPayingYouNeedToComeBackToConfirmThePaymentResultToEnsureTheSmoothDistributionOfThePurchasedContent": "支付後需要回來確認支付結果，確保購買內容順利發放!",
	"order.PaymentAmount": "支付金額",
	"order.readAndAgree": "已閱讀並同意",
	"order.AlipayScanCodeSigningContract": "支付寶掃碼簽約",
	"order.GoToAlipayToSignAContract": "前往支付寶簽約",
	"order.cancelPayment": "取消支付",
	"order.waitForPayment": "等待支付…",
	"order.MallCashierPagepaymentConfirmationPopupconfirmationButton": "商城收銀台頁_支付確認彈窗_確認按鈕",
	"order.Paid": "已支付",
	"order.PaymentIsSuccessfulGoToReceive": "支付成功，去領取",
	"order.unpaid": "未支付",
	"order.PaymentFailedRePay": "支付失敗，重新支付",
	"order.MallCashierPagePaymentConfirmationPopupCloseButton": "商城收銀台頁_支付確認彈窗_關閉按鈕",
	"order.ConfirmationOfPaymentResult": "支付結果確認中",
	"order.RequestingPayment": "請求支付中..."
}